export default "__VITE_ASSET__BQDvOL8t__"